import React from "react";
import { MapPin } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0a0a0a] text-white border-t border-black"
    >
      <div className="section-gutter pt-16 md:pt-20 pb-10">
        {/* Parent brand row */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 pb-10 md:pb-14 border-b border-white/15">
          <div>
            <div className="overline text-white/45 mb-2">The Narzis Group</div>
            <div className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
              Narzis Ventures LLP
            </div>
            <p className="mt-4 max-w-xl text-sm md:text-base text-white/65 leading-relaxed">
              The parent house. Communications, integrated marketing, corporate
              events, dispute PR and international logistics — operating under one
              signature standard across India &amp; the Gulf.
            </p>
          </div>
          <div className="shrink-0 text-[0.65rem] uppercase tracking-[0.22em] text-white/45 md:text-right space-y-1">
            <div>LLP · India</div>
            <div>Registered Office — Kochi, Kerala</div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-8 md:gap-10 pt-12">
          <div className="col-span-12 md:col-span-5">
            <div className="font-serif-display text-5xl md:text-7xl leading-[0.9]">
              Black <em className="italic">&amp;</em>
              <br />
              White.
            </div>
            <p className="mt-6 md:mt-8 max-w-md text-sm md:text-base text-white/70 leading-relaxed">
              A full-service Corporate Communications &amp; Integrated Marketing
              house — advising premium brands, institutions, financial services,
              global logistics and public affairs across India &amp; the Gulf.
            </p>
          </div>

          <div className="col-span-12 md:col-span-4">
            <div className="overline text-white/50 mb-4 md:mb-5">
              Registered Office
            </div>
            <div className="flex items-start gap-3 text-sm text-white/80 leading-relaxed">
              <MapPin size={16} className="mt-1 shrink-0 opacity-70" />
              <div>
                Narzis Ventures LLP
                <br />
                Ravipuram, Door No. 3100, Ward 61
                <br />
                M.G. Road, Kochi
                <br />
                Ernakulam — 682016, Kerala, India
              </div>
            </div>

            <div className="overline text-white/50 mt-8 mb-4 md:mb-5">
              Studio
            </div>
            <ul className="space-y-3 text-sm text-white/80">
              <li>
                <a href="tel:+919847659129" className="nav-link">
                  +91 98476 59129
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@blackandwhitekampany.com"
                  className="nav-link break-all"
                >
                  info@blackandwhitekampany.com
                </a>
              </li>
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3">
            <div className="overline text-white/50 mb-4 md:mb-5">Practice</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li>Corporate Communications</li>
              <li>Integrated Marketing</li>
              <li>Premium Brand &amp; Luxury</li>
              <li>Education &amp; Institutions</li>
              <li>Banking &amp; Financial Services</li>
              <li>Corporate Events</li>
              <li>Dispute &amp; Litigation PR</li>
              <li>International Logistics</li>
              <li>Political &amp; Public Affairs</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 md:mt-20 pt-6 border-t border-white/15 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/55">
          <span>
            © {year} Black &amp; White Kampany — a unit of
            <span className="text-white/80 font-semibold">
              {" "}
              Narzis Ventures LLP
            </span>
            . All rights reserved.
          </span>
          <span className="font-serif-display italic">
            Kochi · Dubai · Doha · Riyadh · Singapore · London
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
